var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-bloqueio-page"
  }, [_c('div', {
    staticClass: "pdv-bloqueio-card"
  }, [_vm._m(0), _c('h1', [_vm._v("Operacao bloqueada no PDV")]), _c('p', {
    staticClass: "pdv-bloqueio-desc"
  }, [_vm._v(" A empresa esta temporariamente sem permissao para operar no PDV Desktop. ")]), _c('div', {
    staticClass: "pdv-bloqueio-info"
  }, [_c('div', {
    staticClass: "pdv-bloqueio-line"
  }, [_c('span', {
    staticClass: "pdv-bloqueio-label"
  }, [_vm._v("Motivo:")]), _c('span', [_vm._v(_vm._s(_vm.motivoBloqueio))])]), _vm.codigoBloqueio ? _c('div', {
    staticClass: "pdv-bloqueio-line"
  }, [_c('span', {
    staticClass: "pdv-bloqueio-label"
  }, [_vm._v("Codigo:")]), _c('span', [_vm._v(_vm._s(_vm.codigoBloqueio))])]) : _vm._e()]), _c('div', {
    staticClass: "pdv-bloqueio-actions"
  }, [_c('button', {
    staticClass: "pdv-bloqueio-btn pdv-bloqueio-btn--primary",
    on: {
      "click": _vm.revalidarStatus
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _vm._v(" Revalidar status ")]), _c('button', {
    staticClass: "pdv-bloqueio-btn",
    on: {
      "click": _vm.abrirConfiguracaoTerminal
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  }), _vm._v(" Configuracao do terminal ")])]), _c('small', {
    staticClass: "pdv-bloqueio-help"
  }, [_vm._v(" Se o bloqueio persistir, entre em contato com o suporte para regularizacao da assinatura/plano. ")])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-bloqueio-icon"
  }, [_c('i', {
    staticClass: "fas fa-ban"
  })]);
}];
export { render, staticRenderFns };